/* facts-rail.js · Verhalten der Section facts-system-rail
 * ------------------------------------------------------------------
 * Drei Aufgaben, mehr nicht:
 *   1 Blaetter-Tasten (Desktop) mit korrektem Aktiv/Inaktiv-Zustand
 *   2 Ziehen mit der Maus, damit die Schiene am Desktop ohne Rad bedienbar ist
 *   3 Tastatur: Pfeil links/rechts, wenn die Schiene den Fokus hat
 *
 * Regel aus dem Section-Standard (2026-08-12): im Scroll-Listener NIE direkt
 * messen. scrollWidth/clientWidth erzwingen Layout, und zwar pro Ereignis.
 * Alle Messungen laufen gebuendelt in einem rAF.
 *
 * Welches Element scrollt, haengt am Breakpoint: auf Desktop die Schiene
 * selbst, mobil nur die Modulgruppe. Beide tragen data-fsr-scroller; wir
 * bedienen jeweils das, das gerade wirklich ueberlaeuft.
 */
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollables(root) {
    var all = root.querySelectorAll('[data-fsr-scroller]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      /* Ueberlauf allein reicht NICHT: mobil ist die Schiene ein
       * Block mit overflow:visible, dessen Modulgruppe breiter ist -
       * scrollWidth ist dann groesser, scrollen laesst sie sich aber
       * nicht. Die Ueberlaufeigenschaft mitpruefen. */
      var ox = getComputedStyle(el).overflowX;
      if (ox !== 'auto' && ox !== 'scroll') continue;
      if (el.scrollWidth - el.clientWidth > 2) out.push(el);
    }
    return out;
  }

  function activeScroller(root) {
    var list = scrollables(root);
    return list.length ? list[0] : null;
  }

  function step(el) {
    var card = el.querySelector('.fsr__card');
    if (!card) return Math.round(el.clientWidth * 0.8);
    var gap = parseFloat(getComputedStyle(el).columnGap || getComputedStyle(el).gap || '0') || 0;
    return Math.round(card.getBoundingClientRect().width + gap);
  }

  function init(root) {
    var prev = root.querySelector('[data-fsr-prev]');
    var next = root.querySelector('[data-fsr-next]');
    var frame = 0;

    function sync() {
      frame = 0;
      var el = activeScroller(root);
      if (!prev || !next) return;
      if (!el) { prev.disabled = true; next.disabled = true; return; }
      var max = el.scrollWidth - el.clientWidth;
      prev.disabled = el.scrollLeft <= 2;
      next.disabled = el.scrollLeft >= max - 2;
    }
    function queue() { if (!frame) frame = requestAnimationFrame(sync); }

    function go(dir) {
      var el = activeScroller(root);
      if (!el) return;
      el.scrollBy({ left: dir * step(el), behavior: RM.matches ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var rails = root.querySelectorAll('[data-fsr-scroller]');
    for (var i = 0; i < rails.length; i++) {
      (function (el) {
        el.addEventListener('scroll', queue, { passive: true });

        el.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        });

        /* Ziehen mit der Maus. Nur bei feinem Zeiger - auf Touch macht das
         * der Browser besser. Ab 4px Weg gilt es als Ziehen, dann werden die
         * Links stillgelegt, damit das Loslassen keine Navigation ausloest. */
        var down = false, startX = 0, startL = 0, moved = false;
        el.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true; moved = false; startX = e.clientX; startL = el.scrollLeft;
        });
        el.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (!moved && Math.abs(dx) < 4) return;
          if (!moved) { moved = true; el.classList.add('is-drag'); el.setPointerCapture(e.pointerId); }
          el.scrollLeft = startL - dx;
        });
        function end() {
          if (!down) return;
          down = false;
          if (moved) setTimeout(function () { el.classList.remove('is-drag'); }, 0);
        }
        el.addEventListener('pointerup', end);
        el.addEventListener('pointercancel', end);
        el.addEventListener('pointerleave', end);
      })(rails[i]);
    }

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(queue);
      ro.observe(root);
    }
    window.addEventListener('resize', queue, { passive: true });
    queue();
  }

  function boot() {
    var roots = document.querySelectorAll('facts-system-rail');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].dataset.fsrReady) continue;
      roots[i].dataset.fsrReady = '1';
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Theme-Editor: Section neu geladen -> erneut verdrahten */
  document.addEventListener('shopify:section:load', boot);
})();
